/* ──────────────────────────────────────────────────────────────────────────
   کادر هشدار یک‌دست برنامه.

   رنگ‌ها هماهنگ با طراحی سامانه (سرمه‌ای #0a1628→#1a2f50، طلایی #C8A84B).

   استفاده:
     <WarningDialog
       title="هشدار"
       lines={['خط اول', 'خط دوم']}
       confirmLabel="ادامه"
       cancelLabel="لغو"
       onConfirm={...}
       onCancel={...}
     />

   نکته: دکمهٔ «لغو» عمداً دکمهٔ پیش‌فرض (پررنگ) است، چون در همهٔ این هشدارها
   مسیرِ توصیه‌شده همان انصراف است.
   ────────────────────────────────────────────────────────────────────────── */
import React, { useEffect, useRef } from 'react';

export default function WarningDialog({
  title = 'هشدار',
  lines = [],
  hint = '',
  confirmLabel = 'ادامه',
  cancelLabel = 'لغو',
  onConfirm,
  onCancel,
  tone = 'warn',            // warn | danger
}) {
  const cancelRef = useRef(null);

  // Esc = لغو ، Enter = دکمهٔ پیش‌فرض (لغو)
  useEffect(() => {
    cancelRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); onCancel?.(); }
      if (e.key === 'Enter')  { e.preventDefault(); onCancel?.(); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  const accent = tone === 'danger' ? '#c62828' : '#C8A84B';

  return (
    <div style={s.overlay} onClick={onCancel}>
      <div style={s.card} onClick={(e) => e.stopPropagation()}
        role="alertdialog" aria-modal="true" aria-label={title}>

        <div style={s.header}>
          <div style={s.headTitle}>
            <span style={{ ...s.badge, background: accent }}>!</span>
            {title}
          </div>
          <button onClick={onCancel} style={s.close} aria-label="بستن">✕</button>
        </div>

        <div style={s.body}>
          <div style={{ ...s.note, borderRightColor: accent }}>
            {lines.map((ln, i) => (
              <div key={i} style={{ marginBottom: i < lines.length - 1 ? '8px' : 0 }}>{ln}</div>
            ))}
          </div>
          {hint && <div style={s.hint}>{hint}</div>}
        </div>

        <div style={s.footer}>
          <button onClick={onConfirm} style={s.btnGhost}>{confirmLabel}</button>
          <button ref={cancelRef} onClick={onCancel} style={s.btnPrimary}>{cancelLabel}</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.62)',
    backdropFilter: 'blur(2px)', zIndex: 3000,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px',
  },
  card: {
    background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '620px',
    direction: 'rtl', fontFamily: "'Vazirmatn',Tahoma,sans-serif",
    boxShadow: '0 24px 70px rgba(0,0,0,0.45)', overflow: 'hidden',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 18px', background: 'linear-gradient(135deg,#0a1628,#1a2f50)',
  },
  headTitle: { display: 'flex', alignItems: 'center', gap: '9px',
               fontSize: '14.5px', fontWeight: 700, color: '#fff' },
  badge: {
    width: '22px', height: '22px', borderRadius: '50%', color: '#0a1628',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '14px', fontWeight: 800, lineHeight: 1,
  },
  close: {
    background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)',
    color: '#fff', width: '28px', height: '28px', borderRadius: '50%',
    cursor: 'pointer', fontSize: '12px', fontFamily: 'inherit',
  },
  body: { padding: '20px 20px 6px' },
  note: {
    background: '#fbf7ea', border: '1px solid #ece0c0', borderRight: '4px solid',
    borderRadius: '10px', padding: '14px 16px',
    fontSize: '13px', lineHeight: 2.1, color: '#2b2b2b',
  },
  hint: { marginTop: '10px', fontSize: '12px', color: '#777', lineHeight: 1.9 },
  footer: {
    display: 'flex', justifyContent: 'flex-end', gap: '10px',
    padding: '14px 20px', marginTop: '14px',
    borderTop: '1px solid #f0f2f7', background: '#f8f9fa',
  },
  btnPrimary: {
    padding: '9px 30px', background: 'linear-gradient(135deg,#1a237e,#283593)',
    color: '#fff', border: 'none', borderRadius: '9px', cursor: 'pointer',
    fontFamily: 'inherit', fontSize: '13px', fontWeight: 700,
  },
  btnGhost: {
    padding: '9px 20px', background: '#fff', color: '#5d4037',
    border: '1.5px solid #d8cba8', borderRadius: '9px', cursor: 'pointer',
    fontFamily: 'inherit', fontSize: '12.5px', fontWeight: 600,
  },
};
